import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import ReusableModal from '../../../../../v2/MUI_custom_component/Modal/CustomModal';
import { CustomButton } from '../../../../../v2/MUI_custom_component';

const OCRFailureModal = ({ open, onClose, onTryAgain, onEnterManually, errorMessage }) => {
    return (
        <ReusableModal
            open={open}
            onClose={onClose}
            title=""
            subtitle=""
            maxWidth="500px"
            topMobile="20%"
            topDesktop="50%"
        >
            <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                py: 2
            }}>
                <WarningIcon sx={{ fontSize: 80, color: '#ff9800', mb: 2 }} />
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                    Document Invalid
                </Typography>
                {errorMessage && (
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                        {errorMessage}
                    </Typography>
                )}
                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ width: '100%', gap: 2 }}>
                    <CustomButton
                        variant="outlined"
                        onClick={onTryAgain}
                        label="Try Again"
                        fullWidth
                        sx={{ order: { xs: 2, sm: 1 } }}
                    />
                    <CustomButton
                        variant="filled"
                        onClick={onEnterManually}
                        label="Enter Manually"
                        fullWidth
                        sx={{ order: { xs: 1, sm: 2 } }}
                    />
                </Stack>
            </Box>
        </ReusableModal>
    );
};

export default OCRFailureModal;